import { DailyMotion } from "./dailymotion.js";
import { Facebook } from "./facebook.js";
import { FilePlayer } from "./file-player.js";
import { Mixcloud } from "./mixcloud.js";
import { SoundCloud } from "./soundcloud.js";
import { Streamable } from "./streamable.js";
import { Twitch } from "./twitch.js";
import { Vimeo } from "./vimeo.js";
import { Wistia } from "./wistia.js";
import { YouTube } from "./youtube.js";
const players = [
  YouTube,
  SoundCloud,
  Vimeo,
  Facebook,
  Streamable,
  Wistia,
  Twitch,
  DailyMotion,
  Mixcloud,
  FilePlayer
];
export {
  players
};
//# sourceMappingURL=index.js.map
